// removed by extract-text-webpack-plugin
module.exports = {"advertisement-panel":"Advertisement__advertisement-panel","advertisementPanel":"Advertisement__advertisement-panel","ad-hide":"Advertisement__ad-hide","adHide":"Advertisement__ad-hide","ad-close":"Advertisement__ad-close","adClose":"Advertisement__ad-close","ad-label":"Advertisement__ad-label","adLabel":"Advertisement__ad-label"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Advertisement/Advertisement.css
// module id = 1343
// module chunks = 8